export interface Movie {
  id: number;
  title: string;
  enTitle: string;
  poster: string;
  year: number;
  genres: string[];
  region: string;
  rating: number;
  duration: number;
  director: string;
  cast: string[];
  releaseDate: string;
  synopsis: string;
  views: number;
}

export const movies: Movie[] = [
  {
    id: 1,
    title: "星际远征",
    enTitle: "Interstellar Odyssey",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20movie%20poster%2C%20lone%20astronaut%20silhouette%20before%20a%20giant%20glowing%20planet%2C%20deep%20blue%20and%20orange%20rim%20light%2C%20epic%20space%20scale%2C%20dramatic%20contrast%2C%20minimal%20title%20space%20at%20bottom%2C%20high%20detail%20film%20grain&width=600&height=900&seq=movie-poster-01&orientation=portrait",
    year: 2025,
    genres: ["scifi", "action"],
    region: "美国",
    rating: 8.7,
    duration: 148,
    director: "克里斯托弗·李",
    cast: ["张远航", "艾米莉亚·陈", "刘维恩", "大卫·福斯特"],
    releaseDate: "2025-08-15",
    synopsis: "当人类最后的希望之星熄灭，一支远征舰队穿越虫洞，前往遥远星系寻找新的家园。面对未知的宇宙、逐渐崩解的时间与彼此间的信任危机，他们必须在绝望中重新定义勇气与牺牲的意义。",
    views: 982340,
  },
  {
    id: 2,
    title: "暗夜追凶",
    enTitle: "Night Chase",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20movie%20poster%2C%20rainy%20neon%20city%20alley%20at%20night%2C%20detective%20in%20long%20coat%20back%20view%2C%20moody%20dark%20blue%20tones%20with%20amber%20street%20lights%2C%20tense%20atmosphere%2C%20mysterious%20shadows%2C%20high%20contrast%20film%20poster&width=600&height=900&seq=movie-poster-02&orientation=portrait",
    year: 2025,
    genres: ["mystery", "drama"],
    region: "中国香港",
    rating: 8.3,
    duration: 132,
    director: "陈国威",
    cast: ["梁俊贤", "周映雪", "黄志远", "林芷若"],
    releaseDate: "2025-07-28",
    synopsis: "一连串看似无关的离奇案件，将一名被停职的刑警重新拉回深渊。随着调查深入，他发现真相早已埋藏在自己最不愿触碰的记忆里。追凶的路上，最大的敌人或许正是自己。",
    views: 764210,
  },
  {
    id: 3,
    title: "城市之光",
    enTitle: "City Lights",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20drama%20movie%20poster%2C%20lone%20figure%20standing%20on%20a%20rooftop%20overlooking%20a%20glittering%20night%20skyline%2C%20warm%20orange%20city%20lights%20against%20deep%20teal%20sky%2C%20melancholy%20cinematic%20mood%2C%20soft%20glow%2C%20high%20detail%20atmospheric%20film%20poster&width=600&height=900&seq=movie-poster-03&orientation=portrait",
    year: 2024,
    genres: ["drama"],
    region: "中国大陆",
    rating: 8.1,
    duration: 118,
    director: "贾樟柯南",
    cast: ["王景春", "谭卓", "章宇", "赵涛"],
    releaseDate: "2024-11-02",
    synopsis: "三个在都市中各自挣扎的普通人，因为一场突如其来的意外命运交汇。他们都在寻找属于自己的那束光，也在彼此身上照见了生活的重量与温柔。",
    views: 512980,
  },
  {
    id: 4,
    title: "爆笑人生",
    enTitle: "Laughing Life",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20comedy%20movie%20poster%2C%20colorful%20playful%20scene%20of%20a%20clumsy%20man%20surrounded%20by%20flying%20objects%2C%20bright%20warm%20yellow%20and%20orange%20palette%2C%20energetic%20fun%20composition%2C%20high%20saturation%2C%20joyful%20upbeat%20film%20poster%20design&width=600&height=900&seq=movie-poster-04&orientation=portrait",
    year: 2025,
    genres: ["comedy"],
    region: "中国大陆",
    rating: 7.6,
    duration: 105,
    director: "宁浩生",
    cast: ["沈腾飞", "马丽娜", "常远", "魏翔"],
    releaseDate: "2025-06-12",
    synopsis: "一个总把日子过砸的倒霉蛋，为了兑现对女儿的承诺，阴差阳错卷入了一场荒唐的创业冒险。笑料百出的背后，是一个普通父亲笨拙却滚烫的爱。",
    views: 688450,
  },
  {
    id: 5,
    title: "深海巨兽",
    enTitle: "Abyss Behemoth",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20deep%20sea%20monster%20movie%20poster%2C%20giant%20shadowy%20creature%20looming%20under%20dark%20ocean%20water%2C%20submarine%20spotlight%20beam%2C%20deep%20blue%20and%20black%20tones%20with%20cyan%20accents%2C%20ominous%20thrilling%20atmosphere%2C%20high%20detail%20blockbuster%20poster&width=600&height=900&seq=movie-poster-05&orientation=portrait",
    year: 2025,
    genres: ["action", "scifi"],
    region: "美国",
    rating: 7.9,
    duration: 126,
    director: "詹姆斯·哈特",
    cast: ["李承宇", "凯特·摩根", "陈奕迅", "山姆·洛克"],
    releaseDate: "2025-09-05",
    synopsis: "一支深海勘探队在马里亚纳海沟发现了一个不该存在的生态系统。当他们惊动了沉睡在黑暗中的庞然巨物，人类才意识到，海洋深处远比太空更令人敬畏。",
    views: 845120,
  },
  {
    id: 6,
    title: "时光恋人",
    enTitle: "Time Lovers",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20romance%20movie%20poster%2C%20silhouettes%20of%20a%20couple%20reaching%20toward%20each%20other%20across%20a%20glowing%20clock%20face%2C%20warm%20golden%20and%20rose%20tones%2C%20dreamy%20soft%20light%2C%20bittersweet%20emotional%20mood%2C%20elegant%20film%20poster%20design&width=600&height=900&seq=movie-poster-06&orientation=portrait",
    year: 2024,
    genres: ["romance", "drama"],
    region: "韩国",
    rating: 8.4,
    duration: 122,
    director: "朴赞旭",
    cast: ["金秀贤", "孙艺珍", "李政宰", "全智贤"],
    releaseDate: "2024-10-18",
    synopsis: "他们相遇在错误的时间里，却相爱得义无反顾。当命运一次次把两人推向不同的人生轨道，这段跨越时光的感情，究竟能否等来一个圆满的答案。",
    views: 632070,
  },
  {
    id: 7,
    title: "追风少年",
    enTitle: "Chasing the Wind",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20sports%20drama%20movie%20poster%2C%20young%20runner%20sprinting%20on%20an%20empty%20track%20at%20dawn%2C%20dynamic%20motion%20blur%2C%20orange%20sunrise%20against%20deep%20blue%20sky%2C%20inspirational%20energetic%20mood%2C%20high%20detail%20athletic%20film%20poster&width=600&height=900&seq=movie-poster-07&orientation=portrait",
    year: 2025,
    genres: ["drama", "action"],
    region: "中国大陆",
    rating: 7.8,
    duration: 114,
    director: "韩延明",
    cast: ["易烊千玺", "周冬雨", "王传君", "张子枫"],
    releaseDate: "2025-05-20",
    synopsis: "一个被伤病判了死刑的短跑天才，在人生最灰暗的时刻遇见了一位固执的老教练。重新站上跑道的每一步，都是对命运的回答。",
    views: 498760,
  },
  {
    id: 8,
    title: "迷雾山庄",
    enTitle: "Manor in the Mist",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20horror%20mystery%20movie%20poster%2C%20abandoned%20gothic%20mansion%20shrouded%20in%20dense%20fog%2C%20single%20flickering%20window%20light%2C%20cold%20desaturated%20blue%20and%20grey%20tones%2C%20eerie%20unsettling%20atmosphere%2C%20high%20detail%20creepy%20film%20poster&width=600&height=900&seq=movie-poster-08&orientation=portrait",
    year: 2024,
    genres: ["horror", "mystery"],
    region: "日本",
    rating: 7.5,
    duration: 108,
    director: "中田秀夫",
    cast: ["染谷将太", "满岛光", "绫濑遥", "妻夫木聪"],
    releaseDate: "2024-09-13",
    synopsis: "一群好友受邀前往深山中的古宅做客，却发现这里每逢午夜便会响起无法解释的低语。当迷雾笼罩山庄，每个人心底的秘密也开始浮现。",
    views: 421330,
  },
  {
    id: 9,
    title: "龙腾四海",
    enTitle: "Dragon Rising",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20martial%20arts%20action%20movie%20poster%2C%20silhouette%20of%20a%20fighter%20mid%20leap%20against%20a%20burning%20orange%20sky%2C%20flying%20embers%20and%20motion%20lines%2C%20deep%20red%20and%20gold%20tones%2C%20powerful%20dramatic%20energy%2C%20high%20detail%20epic%20poster&width=600&height=900&seq=movie-poster-09&orientation=portrait",
    year: 2025,
    genres: ["action"],
    region: "中国香港",
    rating: 8.0,
    duration: 130,
    director: "袁和平生",
    cast: ["甄子丹", "吴京", "张晋", "托尼·贾"],
    releaseDate: "2025-07-04",
    synopsis: "门派纷争与家国大义交织，一位隐退多年的武者被迫重返江湖。面对昔日师门的背叛与新一代的挑战，他必须用拳头守住最后的道义。",
    views: 559810,
  },
  {
    id: 10,
    title: "未来纪元",
    enTitle: "Future Era",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20cyberpunk%20science%20fiction%20movie%20poster%2C%20futuristic%20city%20with%20towering%20holographic%20structures%2C%20lone%20figure%20in%20high%20tech%20armor%2C%20violet%20and%20orange%20neon%20fusion%2C%20dystopian%20awe%20atmosphere%2C%20high%20detail%20sci-fi%20poster%20design&width=600&height=900&seq=movie-poster-10&orientation=portrait",
    year: 2025,
    genres: ["scifi", "action"],
    region: "美国",
    rating: 8.2,
    duration: 140,
    director: "丹尼斯·维伦",
    cast: ["瑞恩·高斯林", "弗洛伦丝·皮尤", "陈冲", "杰瑞德·莱托"],
    releaseDate: "2025-10-24",
    synopsis: "在人工智能统治的纪元，人类的情感成了最昂贵的违禁品。一名负责销毁「记忆异常者」的执法者，却因为一段残留的记忆走上了反抗之路。",
    views: 903450,
  },
  {
    id: 11,
    title: "江湖传说",
    enTitle: "Legend of the Jianghu",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20wuxia%20martial%20arts%20movie%20poster%2C%20lone%20swordsman%20standing%20on%20a%20cliff%20in%20falling%20snow%2C%20flowing%20silver%20and%20deep%20blue%20tones%2C%20misty%20ink%20wash%20atmosphere%2C%20elegant%20dramatic%20composition%2C%20high%20detail%20epic%20film%20poster&width=600&height=900&seq=movie-poster-11&orientation=portrait",
    year: 2024,
    genres: ["action", "drama"],
    region: "中国大陆",
    rating: 7.7,
    duration: 136,
    director: "徐克安",
    cast: ["张震", "倪妮", "梁朝伟", "刘亦菲"],
    releaseDate: "2024-12-06",
    synopsis: "乱世之中，一柄断剑，一段旧怨。曾经的天下第一如今只想归隐山林，却因一个少女的央求，再一次踏入波谲云诡的江湖漩涡。",
    views: 476540,
  },
  {
    id: 12,
    title: "青春纪念册",
    enTitle: "Yearbook of Youth",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20coming%20of%20age%20romance%20movie%20poster%2C%20two%20high%20school%20students%20on%20a%20sunlit%20campus%20path%2C%20warm%20nostalgic%20golden%20hour%20light%2C%20soft%20green%20and%20amber%20tones%2C%20youthful%20bittersweet%20mood%2C%20high%20detail%20film%20poster&width=600&height=900&seq=movie-poster-12&orientation=portrait",
    year: 2024,
    genres: ["romance", "drama"],
    region: "中国大陆",
    rating: 7.4,
    duration: 110,
    director: "张一白",
    cast: ["刘昊然", "谭松韵", "彭昱畅", "张子枫"],
    releaseDate: "2024-08-09",
    synopsis: "毕业那年夏天，他们把青春写进一本纪念册。多年后翻开，那些没说出口的话、没走完的路，依然在记忆里闪闪发光。",
    views: 388920,
  },
  {
    id: 13,
    title: "幻影神探",
    enTitle: "Phantom Detective",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20detective%20movie%20poster%2C%20cracked%20magnifying%20glass%20revealing%20a%20hidden%20face%2C%20surreal%20double%20exposure%20composition%2C%20deep%20blue%20and%20amber%20tones%2C%20puzzling%20atmosphere%2C%20high%20detail%20suspense%20film%20poster&width=600&height=900&seq=movie-poster-13&orientation=portrait",
    year: 2025,
    genres: ["mystery"],
    region: "英国",
    rating: 8.5,
    duration: 124,
    director: "盖·里奇森",
    cast: ["本尼迪克特", "汤姆·哈迪", "凯拉·奈特莉", "科林·费斯"],
    releaseDate: "2025-04-16",
    synopsis: "一位擅长洞察人心的神探，接手了一桩「没有凶手」的密室奇案。当幻影一次次现身，他不得不怀疑，自己的推理本身是否也是一场骗局。",
    views: 601240,
  },
  {
    id: 14,
    title: "山城往事",
    enTitle: "Tales of the Mountain City",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20drama%20movie%20poster%2C%20old%20mountain%20town%20with%20layered%20stone%20houses%20in%20rain%2C%20warm%20lantern%20light%20in%20windows%2C%20muted%20green%20and%20amber%20palette%2C%20nostalgic%20wistful%20mood%2C%20high%20detail%20atmospheric%20film%20poster&width=600&height=900&seq=movie-poster-14&orientation=portrait",
    year: 2023,
    genres: ["drama"],
    region: "中国大陆",
    rating: 8.0,
    duration: 128,
    director: "王小帅",
    cast: ["王砚辉", "咏梅", "黄尧", "段奕宏"],
    releaseDate: "2023-11-17",
    synopsis: "一座即将被拆迁的山城，承载着三代人的记忆。在外漂泊多年的儿子回到故乡，才发现父亲早已把所有的牵挂，藏进了那些沉默的岁月里。",
    views: 342150,
  },
  {
    id: 15,
    title: "太空救援",
    enTitle: "Space Rescue",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20space%20survival%20movie%20poster%2C%20astronaut%20clinging%20to%20a%20damaged%20space%20station%20module%2C%20glowing%20earth%20below%2C%20deep%20blue%20and%20warm%20orange%20contrast%2C%20tension%20and%20danger%2C%20high%20detail%20thriller%20poster&width=600&height=900&seq=movie-poster-15&orientation=portrait",
    year: 2025,
    genres: ["scifi", "action", "drama"],
    region: "美国",
    rating: 8.1,
    duration: 118,
    director: "阿方索·卡隆",
    cast: ["桑德拉·布洛克", "马修·麦康纳", "克里斯·埃文斯", "景甜"],
    releaseDate: "2025-03-21",
    synopsis: "空间站遭遇陨石撞击，仅存的两名宇航员必须依靠有限的氧气与资源，完成一场几乎不可能的自救。在浩瀚寂静的太空中，每一次呼吸都弥足珍贵。",
    views: 758630,
  },
  {
    id: 16,
    title: "欢乐家庭",
    enTitle: "Happy Family",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20family%20comedy%20movie%20poster%2C%20cheerful%20family%20of%20four%20in%20a%20bright%20living%20room%20with%20confetti%2C%20warm%20sunny%20yellow%20and%20coral%20palette%2C%20playful%20heartwarming%20energy%2C%20high%20detail%20upbeat%20film%20poster&width=600&height=900&seq=movie-poster-16&orientation=portrait",
    year: 2024,
    genres: ["comedy", "drama"],
    region: "中国大陆",
    rating: 7.3,
    duration: 102,
    director: "徐峥明",
    cast: ["黄渤", "徐峥", "陶虹", "沈腾"],
    releaseDate: "2024-07-12",
    synopsis: "一个矛盾重重的中年家庭，因为爷爷奶奶的「结婚纪念日」被迫凑到一起。鸡飞狗跳的相处中，他们重新找回了久违的亲情与欢笑。",
    views: 356410,
  },
  {
    id: 17,
    title: "末日黎明",
    enTitle: "Dawn of the End",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20post%20apocalyptic%20disaster%20movie%20poster%2C%20lone%20survivor%20walking%20through%20ruined%20city%20toward%20a%20glowing%20dawn%2C%20smoke%20and%20ash%20in%20the%20air%2C%20deep%20grey%20and%20orange%20tones%2C%20epic%20hopeful%20mood%2C%20high%20detail%20film%20poster&width=600&height=900&seq=movie-poster-17&orientation=portrait",
    year: 2025,
    genres: ["scifi", "drama"],
    region: "美国",
    rating: 7.9,
    duration: 134,
    director: "罗兰·艾默里奇",
    cast: ["汤姆·克鲁斯", "艾米莉·布朗特", "陈坤", "杰西卡·查斯坦"],
    releaseDate: "2025-01-31",
    synopsis: "当太阳风暴席卷全球，文明一夜之间崩塌。一位父亲带着女儿穿越废墟，只为抵达传说中的避难所。在末日的尽头，他们寻找的是活下去的理由。",
    views: 712880,
  },
  {
    id: 18,
    title: "蝴蝶夫人",
    enTitle: "Madame Butterfly",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20drama%20movie%20poster%2C%20elegant%20woman%20in%20a%20flowing%20red%20dress%20surrounded%20by%20glowing%20butterflies%2C%20warm%20crimson%20and%20gold%20palette%2C%20dreamlike%20romantic%20atmosphere%2C%20high%20detail%20artistic%20film%20poster&width=600&height=900&seq=movie-poster-18&orientation=portrait",
    year: 2023,
    genres: ["romance", "drama"],
    region: "法国",
    rating: 8.3,
    duration: 126,
    director: "吕克·贝松",
    cast: ["玛丽昂·歌迪亚", "蒂姆·罗斯", "汤唯", "路易·加瑞尔"],
    releaseDate: "2023-09-22",
    synopsis: "上世纪的一段异国情缘，让一位东方女子耗尽一生去等待。她用全部的爱与执着，谱写出一曲令人心碎的绝唱。",
    views: 298470,
  },
  {
    id: 19,
    title: "铁血远征军",
    enTitle: "Iron Expedition",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20war%20epic%20movie%20poster%2C%20group%20of%20soldiers%20marching%20through%20smoke%20and%20mud%20at%20dusk%2C%20tattered%20flags%20and%20determined%20faces%2C%20desaturated%20olive%20and%20amber%20palette%2C%20grim%20heroic%20atmosphere%2C%20high%20detail%20film%20poster&width=600&height=900&seq=movie-poster-19&orientation=portrait",
    year: 2024,
    genres: ["war", "drama"],
    region: "中国大陆",
    rating: 8.6,
    duration: 152,
    director: "冯小刚",
    cast: ["张译", "吴京", "段奕宏", "朱亚文"],
    releaseDate: "2024-12-20",
    synopsis: "烽火连天的年代，一支远征军踏上了保家卫国的漫漫长路。他们中有的是农家子弟，有的是热血书生，却在战火中淬炼成钢铁般的战士。",
    views: 634720,
  },
  {
    id: 20,
    title: "小怪物大冒险",
    enTitle: "Little Monster Adventure",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20animated%20adventure%20movie%20poster%2C%20cute%20round%20fuzzy%20monster%20with%20big%20eyes%20on%20a%20colorful%20journey%2C%20vibrant%20teal%20and%20orange%20palette%2C%20whimsical%20playful%20mood%2C%20high%20detail%20pixar%20style%20family%20film%20poster&width=600&height=900&seq=movie-poster-20&orientation=portrait",
    year: 2025,
    genres: ["animation", "comedy"],
    region: "美国",
    rating: 8.2,
    duration: 96,
    director: "彼特·道格特",
    cast: ["汤姆·汉克斯", "艾米·波勒", "刘亦菲", "克里斯·帕拉特"],
    releaseDate: "2025-02-14",
    synopsis: "一只被同伴嫌弃的小怪物，为了证明自己并不平凡，踏上了一场穿越奇幻森林的冒险。一路上，他收获了友谊，也找到了真正的自我。",
    views: 545190,
  },
  {
    id: 21,
    title: "沉默的证人",
    enTitle: "The Silent Witness",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20legal%20thriller%20movie%20poster%2C%20single%20empty%20witness%20chair%20in%20a%20dim%20courtroom%20under%20a%20beam%20of%20light%2C%20deep%20blue%20and%20cold%20grey%20tones%2C%20tense%20mysterious%20atmosphere%2C%20high%20detail%20dramatic%20poster&width=600&height=900&seq=movie-poster-21&orientation=portrait",
    year: 2024,
    genres: ["mystery", "drama"],
    region: "韩国",
    rating: 8.0,
    duration: 116,
    director: "奉俊昊民",
    cast: ["宋康昊", "崔岷植", "金惠秀", "河正宇"],
    releaseDate: "2024-06-28",
    synopsis: "一桩轰动全国的命案，唯一的目击者却始终保持沉默。当真相被层层掩盖，一位执着的检察官决定用一场审判，让沉默者开口。",
    views: 389240,
  },
  {
    id: 22,
    title: "海阔天空",
    enTitle: "Boundless Sky",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20music%20drama%20movie%20poster%2C%20young%20musician%20playing%20guitar%20on%20a%20rooftop%20against%20a%20wide%20sunset%20sky%2C%20warm%20amber%20and%20deep%20blue%20gradient%2C%20passionate%20hopeful%20mood%2C%20high%20detail%20inspiring%20film%20poster&width=600&height=900&seq=movie-poster-22&orientation=portrait",
    year: 2023,
    genres: ["drama"],
    region: "中国大陆",
    rating: 7.6,
    duration: 120,
    director: "张猛",
    cast: ["彭于晏", "张子枫", "黄轩", "倪妮"],
    releaseDate: "2023-08-11",
    synopsis: "一个怀揣音乐梦想的年轻人，在城市的地下通道里唱了整整五年。当机会终于来临，他必须在天赋与现实之间，做出属于自己的选择。",
    views: 276830,
  },
  {
    id: 23,
    title: "极速狂飙",
    enTitle: "Turbo Rush",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20racing%20action%20movie%20poster%2C%20supercar%20drifting%20through%20a%20night%20city%20street%20with%20neon%20light%20trails%2C%20orange%20and%20deep%20blue%20tones%2C%20high%20speed%20energy%20motion%2C%20high%20detail%20adrenaline%20film%20poster&width=600&height=900&seq=movie-poster-23&orientation=portrait",
    year: 2025,
    genres: ["action"],
    region: "美国",
    rating: 7.8,
    duration: 128,
    director: "林诣彬",
    cast: ["范·迪塞尔", "杰森·斯坦森", "查理兹·塞隆", "韩庚"],
    releaseDate: "2025-05-23",
    synopsis: "一场横跨三大洲的终极赛车对决，让昔日的对手被迫联手。当速度成为唯一的语言，谁能在生与死的边缘踩下最后那脚油门。",
    views: 667410,
  },
  {
    id: 24,
    title: "雨中曲",
    enTitle: "Song in the Rain",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20musical%20movie%20poster%2C%20couple%20dancing%20under%20a%20streetlamp%20in%20gentle%20rain%2C%20warm%20golden%20glow%20reflecting%20on%20wet%20street%2C%20soft%20amber%20and%20teal%20tones%2C%20dreamy%20romantic%20mood%2C%20high%20detail%20elegant%20film%20poster&width=600&height=900&seq=movie-poster-24&orientation=portrait",
    year: 2024,
    genres: ["romance", "comedy"],
    region: "英国",
    rating: 8.1,
    duration: 108,
    director: "理查德·柯蒂斯",
    cast: ["休·格兰特", "艾玛·斯通", "瑞恩·高斯林", "凯拉·奈特莉"],
    releaseDate: "2024-04-05",
    synopsis: "一个平凡的雨夜，一把共撑的伞，一场不期而遇的心动。当生活的琐碎与现实的考验接踵而至，他们学会了在雨中唱出属于自己的歌。",
    views: 315680,
  },
];